document.addEventListener('DOMContentLoaded', () => {
  const menuBtn = document.querySelector('[data-hana-menu-toggle]');
  const mobileMenu = document.querySelector('[data-hana-mobile-menu]');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', () => {
      const open = menuBtn.getAttribute('aria-expanded') === 'true';
      menuBtn.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
    });
  }

  // Shopify collection facets: desktop dropdowns and mobile drawer.
  const facetsDrawer = document.querySelector('#HanaFacetsDrawer');
  const facetsOpeners = [...document.querySelectorAll('[data-hana-facets-open]')];
  let facetsLastTrigger = null;
  const setFacetsDrawer = open => {
    if (!facetsDrawer) return;
    facetsDrawer.setAttribute('aria-hidden', String(!open));
    facetsOpeners.forEach(button => button.setAttribute('aria-expanded', String(open)));
    document.body.classList.toggle('hana-facets-open', open);
    if (open) facetsDrawer.querySelector('[data-hana-facets-close]')?.focus();
    else facetsLastTrigger?.focus();
  };
  facetsOpeners.forEach(button => button.addEventListener('click', () => {
    facetsLastTrigger = button;
    setFacetsDrawer(true);
  }));
  facetsDrawer?.querySelectorAll('[data-hana-facets-close]').forEach(button => {
    button.addEventListener('click', () => setFacetsDrawer(false));
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && facetsDrawer?.getAttribute('aria-hidden') === 'false') setFacetsDrawer(false);
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-hana-facet][open]').forEach(facet => {
      if (!facet.contains(event.target)) facet.removeAttribute('open');
    });
  });

  // Compact footer accordion on mobile; desktop keeps the original columns open.
  const footerMedia = window.matchMedia('(max-width: 700px)');
  document.querySelectorAll('[data-hana-footer-toggle]').forEach(toggle => {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    const paint = open => {
      toggle.setAttribute('aria-expanded', String(open));
      panel.classList.toggle('is-open', open);
    };
    paint(false);
    toggle.addEventListener('click', () => {
      if (!footerMedia.matches) return;
      paint(toggle.getAttribute('aria-expanded') !== 'true');
    });
  });

  const formatMoney = cents => new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR'
  }).format((Number(cents) || 0) / 100);

  // Product gallery.
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const thumbs = [...gallery.querySelectorAll('[data-gallery-image]')];
    const mainImage = gallery.querySelector('[data-product-gallery-main] img');
    thumbs.forEach(thumb => thumb.addEventListener('click', () => {
      thumbs.forEach(item => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (mainImage && thumb.dataset.galleryImage) {
        mainImage.src = thumb.dataset.galleryImage;
        mainImage.srcset = '';
        mainImage.alt = thumb.dataset.galleryAlt || '';
      }
    }));
  });

  // Product variants + availability.
  const productFormWrap = document.querySelector('[data-product-form]');
  const productJson = document.querySelector('[data-product-json]');
  if (productFormWrap && productJson) {
    const form = productFormWrap.querySelector('form');
    const variants = JSON.parse(productJson.textContent);
    const hiddenId = form?.querySelector('[data-variant-id]');
    const priceEl = document.querySelector('[data-product-price]');
    const purchase = productFormWrap.querySelector('[data-product-purchase]');
    const oos = productFormWrap.querySelector('[data-product-oos]');
    const stock = productFormWrap.querySelector('[data-product-stock]');

    const updateVariant = () => {
      if (!form || !hiddenId) return;
      const fieldsets = [...form.querySelectorAll('fieldset')];
      const selected = fieldsets.map(fs => fs.querySelector('input:checked')?.value).filter(Boolean);
      const variant = fieldsets.length
        ? variants.find(v => v.options.every((option, index) => option === selected[index]))
        : variants.find(v => String(v.id) === String(hiddenId.value)) || variants[0];
      if (!variant) return;
      hiddenId.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (purchase) purchase.hidden = !variant.available;
      if (oos) oos.hidden = Boolean(variant.available);
      if (stock) {
        stock.classList.toggle('is-unavailable', !variant.available);
        stock.innerHTML = variant.available ? '<i></i> Disponible bajo pedido' : 'Temporalmente sin stock';
      }
    };

    form?.addEventListener('change', updateVariant);
    updateVariant();
  }

  // Browser wishlist. Persistent account/email wishlist can replace this hook later.
  document.querySelectorAll('[data-hana-wishlist]').forEach(button => {
    const storageKey = 'hana_wishlist';
    const id = String(button.dataset.productHandle || button.dataset.productId || '');
    const label = button.querySelector('[data-wishlist-label]');
    const read = () => {
      try { return JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (_) { return []; }
    };
    const paint = () => {
      const active = read().includes(id);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      if (label) label.textContent = active ? '♥ GUARDADO' : '♡ GUARDAR';
    };
    button.addEventListener('click', () => {
      const list = read();
      const next = list.includes(id) ? list.filter(item => item !== id) : [...list, id];
      localStorage.setItem(storageKey, JSON.stringify(next));
      paint();
      window.dispatchEvent(new CustomEvent('hana:wishlist-change', { detail: { productId: id, active: next.includes(id) } }));
    });
    paint();
  });

  const wishlistIndicator = document.querySelector('[data-wishlist-indicator]');
  const paintWishlistIndicator = () => {
    if (!wishlistIndicator) return;
    let items = [];
    try { items = JSON.parse(localStorage.getItem('hana_wishlist') || '[]'); } catch (_) {}
    wishlistIndicator.hidden = !Array.isArray(items) || items.length === 0;
  };
  paintWishlistIndicator();
  window.addEventListener('hana:wishlist-change', paintWishlistIndicator);


  // HANA Box cart integrity. A box is a 4/6-product set: removing one item breaks
  // the group and strips all HANA Box properties from the remaining products.
  // This makes the theme ready for a conditional discount Function/app without
  // leaving the discount metadata attached to a partial box.
  const hanaCart = document.querySelector('[data-hana-cart]');
  if (hanaCart) {
    const root = window.Shopify?.routes?.root || '/';
    const changeLine = async (key, quantity, properties) => {
      const payload = { id: key, quantity };
      if (quantity > 0) payload.properties = properties;
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!response.ok) throw new Error('No se pudo actualizar la HANA Box');
      return response.json();
    };
    const cleanBoxProperties = properties => Object.fromEntries(
      Object.entries(properties || {}).filter(([key]) => !key.startsWith('_hana_'))
    );

    hanaCart.addEventListener('click', async event => {
      const button = event.target.closest('[data-hana-box-break-remove]');
      if (!button) return;
      event.preventDefault();
      button.disabled = true;
      const boxId = button.dataset.hanaBoxId;
      const targetKey = button.dataset.cartKey;
      try {
        const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('No se pudo leer la bolsa');
        const cart = await cartResponse.json();
        const group = cart.items.filter(item => item.properties?._hana_box_id === boxId);
        for (const item of group) {
          if (item.key === targetKey) {
            await changeLine(item.key, 0, cleanBoxProperties(item.properties));
          } else {
            await changeLine(item.key, item.quantity, cleanBoxProperties(item.properties));
          }
        }
        window.location.reload();
      } catch (error) {
        console.error(error);
        button.disabled = false;
        button.textContent = 'INTENTAR DE NUEVO';
      }
    });
  }

  // Guided, deterministic advice. A hosted AI can replace this adapter later.
  const adviser = document.querySelector('[data-hana-adviser]');
  if (adviser) {
    const answer = adviser.querySelector('[data-adviser-answer]');
    const title = adviser.querySelector('[data-adviser-answer-title]');
    const copy = adviser.querySelector('[data-adviser-answer-copy]');
    const link = adviser.querySelector('[data-adviser-answer-link]');
    adviser.querySelectorAll('[data-adviser-choice]').forEach(button => button.addEventListener('click', () => {
      adviser.querySelectorAll('[data-adviser-choice]').forEach(item => item.classList.toggle('is-selected', item === button));
      title.textContent = button.dataset.title || '';
      copy.textContent = button.dataset.response || '';
      link.href = button.dataset.link || '/collections/all';
      answer.hidden = false;
      answer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }));
    adviser.querySelector('[data-adviser-reset]')?.addEventListener('click', () => {
      answer.hidden = true;
      adviser.querySelectorAll('[data-adviser-choice]').forEach(item => item.classList.remove('is-selected'));
    });
  }

  // Device-local wishlist page.
  const wishlistPage = document.querySelector('[data-hana-wishlist-page]');
  if (wishlistPage) {
    const loading = wishlistPage.querySelector('[data-wishlist-loading]');
    const empty = wishlistPage.querySelector('[data-wishlist-empty]');
    const grid = wishlistPage.querySelector('[data-wishlist-grid]');
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem('hana_wishlist') || '[]').filter(Boolean); } catch (_) { handles = []; }
    const root = window.Shopify?.routes?.root || '/';
    Promise.all(handles.filter(handle => !/^\d+$/.test(String(handle))).map(async handle => {
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`);
      if (!response.ok) return null;
      return response.json();
    })).then(products => {
      loading.hidden = true;
      products.filter(Boolean).forEach(product => {
        const article = document.createElement('article');
        article.className = 'hana-card';
        const image = product.featured_image ? `<img src="${product.featured_image}" alt="" loading="lazy">` : '';
        article.innerHTML = `<a class="hana-card__media" href="${root}products/${product.handle}">${image}</a><div class="hana-card__copy"><div class="hana-card__vendor">${product.vendor || 'HANA SELECT'}</div><a class="hana-card__title" href="${root}products/${product.handle}">${product.title}</a><div class="hana-card__price">${formatMoney(product.price)}</div><button type="button" data-wishlist-remove="${product.handle}">ELIMINAR</button></div>`;
        grid.appendChild(article);
      });
      empty.hidden = grid.children.length > 0;
      grid.addEventListener('click', event => {
        const button = event.target.closest('[data-wishlist-remove]');
        if (!button) return;
        const next = handles.filter(handle => handle !== button.dataset.wishlistRemove);
        localStorage.setItem('hana_wishlist', JSON.stringify(next));
        button.closest('.hana-card').remove();
        empty.hidden = grid.children.length > 0;
      });
    }).catch(() => { loading.textContent = 'No hemos podido cargar tus favoritos. Inténtalo de nuevo.'; });
  }

  // HANA Box curated configurator.
  const box = document.querySelector('[data-hana-box]');
  if (box && !box.classList.contains('hana-box-simple')) {
    const stepSets = { essential: ['cleanse','treat','moisturise','protect'], complete: ['oil','cleanse','prep','treat','moisturise','protect'] };
    const profileLabels = {
      'breakouts-redness': 'Brotes + rojeces',
      'oily-pores': 'Grasa + poros',
      'sensitive-barrier': 'Sensible + barrera',
      'dehydration': 'Deshidratación',
      'dry-nutrition': 'Seca + nutrición',
      'spots-tone': 'Manchas + tono',
      'firmness-renewal': 'Firmeza + renovación'
    };
    const sizeLabels = { essential: 'ESSENTIAL · 4 productos', complete: 'COMPLETE · 6 productos' };
    const stepMeta = {
      oil: { number: '01', editorial: 'DOUBLE CLEANSE', label: 'Aceite limpiador' },
      cleanse: { number: '02', editorial: 'CLEANSE', label: 'Limpiador' },
      prep: { number: '03', editorial: 'PREP', label: 'Tónico / esencia' },
      treat: { number: '04', editorial: 'TREAT', label: 'Tratamiento' },
      moisturise: { number: '05', editorial: 'MOISTURISE', label: 'Hidratante' },
      protect: { number: '06', editorial: 'PROTECT', label: 'Protección solar' }
    };

    let selectedProfile = '';
    let selectedSize = '';
    let activeStepIndex = 0;
    let drawerStep = '';
    const selections = {};
    const configMap = new Map();

    const candidateFromNode = node => ({
      slot: node.dataset.slot,
      productId: node.dataset.productId,
      title: node.dataset.productTitle,
      vendor: node.dataset.productVendor,
      price: Number(node.dataset.productPrice || 0),
      formattedPrice: node.dataset.productPriceFormatted,
      variant: node.dataset.productVariant,
      available: node.dataset.productAvailable === 'true',
      image: node.dataset.productImage,
      url: node.dataset.productUrl
    });

    box.querySelectorAll('[data-box-config-item]').forEach(item => {
      const key = `${item.dataset.profile}:${item.dataset.step}`;
      const candidates = [...item.querySelectorAll('[data-box-candidate]')].map(candidateFromNode);
      configMap.set(key, [...(configMap.get(key) || []), ...candidates]);
    });

    box.querySelectorAll('[data-box-catalog-candidate]').forEach(node => {
      const profile = window.HanaBoxCatalog?.profileKey(node.dataset.profileLabel);
      const step = window.HanaBoxCatalog?.stepKey(node.dataset.stepLabel);
      if (!profile || !step) return;
      const key = `${profile}:${step}`;
      configMap.set(key, [...(configMap.get(key) || []), candidateFromNode(node)]);
    });

    const ui = box.querySelector('[data-box-builder-ui]');
    const onboarding = box.querySelector('.hana-box-onboarding');
    const stepsEl = box.querySelector('[data-box-steps]');
    const summary = box.querySelector('[data-box-summary-lines]');
    const totalEl = box.querySelector('[data-box-total]');
    const originalTotalEl = box.querySelector('[data-box-original-total]');
    const savingEl = box.querySelector('[data-box-saving]');
    const savingAmountEl = box.querySelector('[data-box-saving-amount]');
    const priceLabelEl = box.querySelector('[data-box-price-label]');
    const notice = box.querySelector('[data-box-notice]');
    const addButton = box.querySelector('[data-box-add]');
    const progress = box.querySelector('[data-box-progress]');
    const progressLabel = box.querySelector('[data-box-progress-label]');
    const profileLabel = box.querySelector('[data-box-profile-label]');
    const sizeLabel = box.querySelector('[data-box-size-label]');
    const drawer = box.querySelector('[data-box-drawer]');
    const alternativesEl = box.querySelector('[data-box-alternatives]');
    const drawerStepEl = box.querySelector('[data-box-drawer-step]');

    const activeSteps = () => stepSets[selectedSize] || [];
    const candidatesFor = step => window.HanaBoxCatalog?.candidatesFor(configMap, selectedProfile, step) || configMap.get(`${selectedProfile}:${step}`) || [];
    const availableFor = step => candidatesFor(step).filter(candidate => candidate.available && candidate.variant);

    const chooseDefault = step => {
      const candidates = availableFor(step);
      const recommended = candidates.find(candidate => candidate.slot === 'recommended');
      if (recommended) return recommended;
      return candidates[0] ? { ...candidates[0], slot: 'recommended' } : null;
    };

    const ensureSelections = () => {
      activeSteps().forEach(step => {
        const stillValid = selections[step] && availableFor(step).some(candidate => candidate.variant === selections[step].variant);
        if (!stillValid) selections[step] = chooseDefault(step);
      });
    };

    const createProductImage = product => {
      const wrap = document.createElement('div');
      wrap.className = 'hana-box-step__image';
      if (product?.image) {
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = product.title || '';
        img.loading = 'lazy';
        wrap.appendChild(img);
      }
      return wrap;
    };

    const renderSteps = () => {
      const steps = activeSteps();
      stepsEl.textContent = '';
      steps.forEach((step, index) => {
        const meta = stepMeta[step];
        const product = selections[step];
        const article = document.createElement('article');
        article.className = `hana-box-step${index === activeStepIndex ? ' is-active' : ''}${product ? '' : ' is-unavailable'}`;
        article.dataset.boxStep = step;

        const top = document.createElement('div');
        top.className = 'hana-box-step__top';
        top.innerHTML = `<span>${meta.number} / ${meta.editorial}</span><strong>${meta.label}</strong>`;
        article.appendChild(top);

        if (product) {
          const selected = document.createElement('div');
          selected.className = 'hana-box-step__selected';
          selected.appendChild(createProductImage(product));
          const vendor = document.createElement('div');
          vendor.className = 'hana-box-step__vendor';
          vendor.textContent = product.vendor.toUpperCase();
          selected.appendChild(vendor);
          const title = document.createElement('h3');
          title.textContent = product.title;
          selected.appendChild(title);
          if (product.slot === 'recommended') {
            const badge = document.createElement('span');
            badge.className = 'hana-choice-badge';
            badge.textContent = 'SELECCIÓN HANA';
            selected.appendChild(badge);
          }
          const price = document.createElement('div');
          price.className = 'hana-box-step__price';
          price.textContent = product.formattedPrice || formatMoney(product.price);
          selected.appendChild(price);
          article.appendChild(selected);

          if (availableFor(step).length > 1) {
            const change = document.createElement('button');
            change.type = 'button';
            change.className = 'hana-change-button';
            change.dataset.boxChange = step;
            change.textContent = 'CAMBIAR';
            article.appendChild(change);
          }
        } else {
          const unavailable = document.createElement('div');
          unavailable.className = 'hana-box-step__empty';
          unavailable.innerHTML = '<strong>Este paso no está disponible ahora mismo.</strong><p>Estamos revisando la mejor alternativa para este perfil.</p>';
          article.appendChild(unavailable);
        }
        stepsEl.appendChild(article);
      });
    };

    const refreshSummary = () => {
      const steps = activeSteps();
      let total = 0;
      let missing = 0;
      summary.textContent = '';
      steps.forEach(step => {
        const product = selections[step];
        if (!product) {
          missing += 1;
          return;
        }
        total += product.price;
        const line = document.createElement('div');
        line.className = 'hana-box-summary-line';
        const name = document.createElement('span');
        name.textContent = `${stepMeta[step].label}: ${product.title}`;
        const price = document.createElement('span');
        price.textContent = product.formattedPrice || formatMoney(product.price);
        line.append(name, price);
        summary.appendChild(line);
      });
      totalEl.textContent = formatMoney(total);
      addButton.disabled = missing > 0 || steps.length === 0;
      notice.textContent = missing > 0 ? `${missing} paso${missing === 1 ? '' : 's'} sin producto disponible.` : 'Todos los productos están disponibles.';
    };

    const updateProgress = () => {
      const count = activeSteps().length || 1;
      activeStepIndex = Math.max(0, Math.min(activeStepIndex, count - 1));
      if (progress) progress.style.width = `${((activeStepIndex + 1) / count) * 100}%`;
      if (progressLabel) progressLabel.textContent = `${activeStepIndex + 1} / ${count}`;
    };

    const render = () => {
      if (!selectedProfile || !selectedSize) return;
      ensureSelections();
      if (profileLabel) profileLabel.textContent = profileLabels[selectedProfile];
      if (sizeLabel) sizeLabel.textContent = sizeLabels[selectedSize];
      renderSteps();
      refreshSummary();
      updateProgress();
      onboarding.hidden = true;
      ui.hidden = false;
    };

    const paintChoices = () => {
      box.querySelectorAll('[data-box-profile]').forEach(button => button.classList.toggle('is-selected', button.dataset.boxProfile === selectedProfile));
      box.querySelectorAll('[data-box-size]').forEach(button => button.classList.toggle('is-selected', button.dataset.boxSize === selectedSize));
    };

    const maybeStart = () => {
      paintChoices();
      if (selectedProfile && selectedSize) {
        activeStepIndex = 0;
        render();
      }
    };

    box.querySelectorAll('[data-box-profile]').forEach(button => button.addEventListener('click', () => {
      selectedProfile = button.dataset.boxProfile;
      Object.keys(selections).forEach(key => delete selections[key]);
      maybeStart();
    }));
    box.querySelectorAll('[data-box-size]').forEach(button => button.addEventListener('click', () => {
      selectedSize = button.dataset.boxSize;
      maybeStart();
    }));

    box.querySelector('[data-box-reset]')?.addEventListener('click', () => {
      ui.hidden = true;
      onboarding.hidden = false;
      activeStepIndex = 0;
      window.scrollTo({ top: box.offsetTop, behavior: 'smooth' });
    });

    stepsEl.addEventListener('click', event => {
      const change = event.target.closest('[data-box-change]');
      if (!change) return;
      drawerStep = change.dataset.boxChange;
      const meta = stepMeta[drawerStep];
      if (drawerStepEl) drawerStepEl.textContent = `${meta.number} / ${meta.editorial} · ${meta.label}`;
      alternativesEl.textContent = '';
      const currentVariant = selections[drawerStep]?.variant;
      availableFor(drawerStep).filter(candidate => candidate.variant !== currentVariant).forEach(candidate => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'hana-alternative';
        button.dataset.altVariant = candidate.variant;
        button.appendChild(createProductImage(candidate));
        const vendor = document.createElement('span');
        vendor.textContent = candidate.vendor.toUpperCase();
        const title = document.createElement('strong');
        title.textContent = candidate.title;
        const price = document.createElement('em');
        price.textContent = candidate.formattedPrice || formatMoney(candidate.price);
        button.append(vendor, title, price);
        alternativesEl.appendChild(button);
      });
      if (!alternativesEl.children.length) {
        const p = document.createElement('p');
        p.textContent = 'No hay otra alternativa disponible para este paso.';
        alternativesEl.appendChild(p);
      }
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
    });

    alternativesEl.addEventListener('click', event => {
      const button = event.target.closest('[data-alt-variant]');
      if (!button || !drawerStep) return;
      const replacement = availableFor(drawerStep).find(candidate => candidate.variant === button.dataset.altVariant);
      if (!replacement) return;
      selections[drawerStep] = replacement;
      drawer.hidden = true;
      document.body.style.overflow = '';
      render();
    });

    box.querySelectorAll('[data-box-close]').forEach(button => button.addEventListener('click', () => {
      drawer.hidden = true;
      document.body.style.overflow = '';
    }));

    box.querySelector('[data-box-next]')?.addEventListener('click', () => {
      activeStepIndex = Math.min(activeSteps().length - 1, activeStepIndex + 1);
      renderSteps();
      updateProgress();
    });
    box.querySelector('[data-box-prev]')?.addEventListener('click', () => {
      activeStepIndex = Math.max(0, activeStepIndex - 1);
      renderSteps();
      updateProgress();
    });

    addButton?.addEventListener('click', async () => {
      const steps = activeSteps();
      const missing = steps.some(step => !selections[step]?.variant);
      if (missing) return;
      const boxId = `HANA-${Date.now().toString(36).toUpperCase()}`;
      const items = steps.map(step => ({
        id: Number(selections[step].variant),
        quantity: 1,
        properties: {
          _hana_box_id: boxId,
          _hana_profile: profileLabels[selectedProfile],
          _hana_box_size: selectedSize,
          _hana_box_expected_count: String(steps.length),
          _hana_box_discount_pct: '8',
          _hana_step: stepMeta[step].label
        }
      }));

      addButton.disabled = true;
      const original = addButton.textContent;
      addButton.textContent = 'AÑADIENDO…';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('No se pudo añadir HANA Box');
        window.location.href = root + 'cart';
      } catch (error) {
        console.error(error);
        addButton.disabled = false;
        addButton.textContent = 'INTENTAR DE NUEVO';
        if (notice) notice.textContent = 'No hemos podido añadir la rutina. Revisa la disponibilidad e inténtalo de nuevo.';
        setTimeout(() => { addButton.textContent = original; }, 2500);
      }
    });
  }

  // HANA Box simple configurator.
  if (box?.classList.contains('hana-box-simple')) {
    const stepSets = {
      essential: ['cleanse', 'treat', 'moisturise', 'protect'],
      complete: ['oil', 'cleanse', 'prep', 'treat', 'moisturise', 'protect']
    };
    const profileLabels = {
      'breakouts-redness': 'Brotes e imperfecciones',
      'oily-pores': 'Poros y grasa',
      'sensitive-barrier': 'Barrera y sensibilidad',
      dehydration: 'Deshidratación',
      'spots-tone': 'Manchas y luminosidad',
      'firmness-renewal': 'Firmeza y líneas'
    };
    const sizeLabels = { essential: 'Essential · 4 productos', complete: 'Complete · 6 productos' };
    const stepMeta = {
      oil: { number: '01', editorial: 'DOUBLE CLEANSE', label: 'Aceite limpiador' },
      cleanse: { number: '02', editorial: 'CLEANSE', label: 'Limpiador acuoso' },
      prep: { number: '03', editorial: 'PREP', label: 'Tónico / esencia' },
      treat: { number: '04', editorial: 'TREAT', label: 'Sérum / tratamiento' },
      moisturise: { number: '05', editorial: 'MOISTURISE', label: 'Hidratante' },
      protect: { number: '06', editorial: 'PROTECT', label: 'Protección solar' }
    };

    let selectedProfile = '';
    let selectedSize = '';
    let drawerStep = '';
    const selections = {};
    const configMap = new Map();
    const prompt = box.querySelector('[data-box-prompt]');
    const ui = box.querySelector('[data-box-builder-ui]');
    const stepsEl = box.querySelector('[data-box-steps]');
    const summary = box.querySelector('[data-box-summary-lines]');
    const totalEl = box.querySelector('[data-box-total]');
    const notice = box.querySelector('[data-box-notice]');
    const addButton = box.querySelector('[data-box-add]');
    const profileLabel = box.querySelector('[data-box-profile-label]');
    const sizeLabel = box.querySelector('[data-box-size-label]');
    const drawer = box.querySelector('[data-box-drawer]');
    const alternativesEl = box.querySelector('[data-box-alternatives]');
    const drawerStepEl = box.querySelector('[data-box-drawer-step]');

    const listValues = raw => {
      if (!raw) return [];
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch (_) {
        return [raw];
      }
    };
    const candidateFromNode = node => ({
      slot: node.dataset.slot,
      productId: node.dataset.productId,
      title: node.dataset.productTitle,
      vendor: node.dataset.productVendor,
      price: Number(node.dataset.productPrice || 0),
      formattedPrice: node.dataset.productPriceFormatted,
      variant: node.dataset.productVariant,
      available: node.dataset.productAvailable === 'true',
      image: node.dataset.productImage,
      url: node.dataset.productUrl
    });
    const addCandidate = (profile, step, candidate) => {
      if (!profile || !step) return;
      const key = `${profile}:${step}`;
      const existing = configMap.get(key) || [];
      if (!existing.some(item => item.variant === candidate.variant)) configMap.set(key, [...existing, candidate]);
    };

    box.querySelectorAll('[data-box-config-item]').forEach(item => {
      item.querySelectorAll('[data-box-candidate]').forEach(node => addCandidate(item.dataset.profile, item.dataset.step, candidateFromNode(node)));
    });
    box.querySelectorAll('[data-box-catalog-candidate]').forEach(node => {
      const profiles = listValues(node.dataset.profileLabel).map(value => window.HanaBoxCatalog?.profileKey(value)).filter(Boolean);
      const steps = listValues(node.dataset.stepLabel).map(value => window.HanaBoxCatalog?.stepKey(value)).filter(Boolean);
      profiles.forEach(profile => steps.forEach(step => addCandidate(profile, step, candidateFromNode(node))));
    });

    const activeSteps = () => stepSets[selectedSize] || [];
    const candidatesFor = step => window.HanaBoxCatalog?.candidatesFor(configMap, selectedProfile, step) || configMap.get(`${selectedProfile}:${step}`) || [];
    const availableFor = step => candidatesFor(step).filter(candidate => candidate.available && candidate.variant);
    const chooseDefault = step => {
      const candidates = availableFor(step);
      return candidates.find(candidate => candidate.slot === 'recommended') || candidates[0] || null;
    };
    const ensureSelections = () => activeSteps().forEach(step => {
      const remainsAvailable = selections[step] && availableFor(step).some(candidate => candidate.variant === selections[step].variant);
      if (!remainsAvailable) selections[step] = chooseDefault(step);
    });
    const createProductImage = product => {
      const wrap = document.createElement('div');
      wrap.className = 'hana-box-simple__product-image';
      if (product?.image) {
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = product.title || '';
        image.loading = 'lazy';
        wrap.appendChild(image);
      }
      return wrap;
    };

    const renderProducts = () => {
      stepsEl.textContent = '';
      activeSteps().forEach(step => {
        const product = selections[step];
        const meta = stepMeta[step];
        const article = document.createElement('article');
        article.className = 'hana-box-simple__product';
        const stepLabel = document.createElement('span');
        stepLabel.className = 'hana-box-simple__product-step';
        stepLabel.textContent = `${meta.number} / ${meta.editorial} · ${meta.label}`;
        article.appendChild(stepLabel);

        if (!product) {
          const empty = document.createElement('div');
          empty.className = 'hana-box-simple__empty';
          empty.textContent = 'Sin producto disponible ahora mismo.';
          article.appendChild(empty);
          stepsEl.appendChild(article);
          return;
        }

        article.appendChild(createProductImage(product));
        const vendor = document.createElement('div');
        vendor.className = 'hana-box-simple__product-vendor';
        vendor.textContent = product.vendor || 'HANA SELECT';
        const title = document.createElement('h3');
        title.textContent = product.title;
        const price = document.createElement('div');
        price.className = 'hana-box-simple__product-price';
        price.textContent = product.formattedPrice || formatMoney(product.price);
        article.append(vendor, title, price);

        if (availableFor(step).length > 1) {
          const change = document.createElement('button');
          change.type = 'button';
          change.className = 'hana-box-simple__change';
          change.dataset.boxChange = step;
          change.dataset.boxChangeSymbol = '';
          change.setAttribute('aria-label', `Cambiar ${meta.label}`);
          change.textContent = '↻';
          article.appendChild(change);
        }
        stepsEl.appendChild(article);
      });
    };

    const refreshSummary = () => {
      let total = 0;
      let missing = 0;
      summary.textContent = '';
      activeSteps().forEach(step => {
        const product = selections[step];
        if (!product) {
          missing += 1;
          return;
        }
        total += product.price;
        const line = document.createElement('div');
        line.className = 'hana-box-simple__summary-line';
        const name = document.createElement('span');
        name.textContent = `${stepMeta[step].label}: ${product.title}`;
        const price = document.createElement('span');
        price.textContent = product.formattedPrice || formatMoney(product.price);
        line.append(name, price);
        summary.appendChild(line);
      });

      const hasEssentialDiscount = selectedSize === 'essential' && missing === 0 && activeSteps().length === 4;
      const discountPct = hasEssentialDiscount ? 8 : 0;
      const discountedTotal = Math.round(total * (100 - discountPct) / 100);
      const saving = total - discountedTotal;
      if (originalTotalEl) originalTotalEl.textContent = formatMoney(total);
      totalEl.textContent = formatMoney(hasEssentialDiscount ? discountedTotal : total);
      if (priceLabelEl) priceLabelEl.textContent = hasEssentialDiscount ? 'HANA BOX · ESSENTIAL' : 'HANA BOX';
      if (savingEl) savingEl.hidden = !hasEssentialDiscount;
      if (savingAmountEl) savingAmountEl.textContent = formatMoney(saving);
      addButton.disabled = missing > 0 || activeSteps().length === 0;
      notice.textContent = missing
        ? `${missing} paso${missing === 1 ? '' : 's'} sin producto disponible.`
        : hasEssentialDiscount
          ? 'Tu HANA Box está completa. El 8% se aplicará mediante Easy Bundles al añadirla.'
          : 'Tu selección está completa.';
    };

    const paintChoices = () => {
      box.querySelectorAll('[data-box-profile]').forEach(button => {
        const selected = button.dataset.boxProfile === selectedProfile;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      box.querySelectorAll('[data-box-size]').forEach(button => {
        const selected = button.dataset.boxSize === selectedSize;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
    };
    const render = () => {
      paintChoices();
      const ready = Boolean(selectedProfile && selectedSize);
      prompt.hidden = ready;
      ui.hidden = !ready;
      if (!ready) return;
      ensureSelections();
      profileLabel.textContent = profileLabels[selectedProfile];
      sizeLabel.textContent = sizeLabels[selectedSize];
      renderProducts();
      refreshSummary();
    };

    box.querySelectorAll('[data-box-profile]').forEach(button => button.addEventListener('click', () => {
      if (selectedProfile !== button.dataset.boxProfile) Object.keys(selections).forEach(key => delete selections[key]);
      selectedProfile = button.dataset.boxProfile;
      render();
    }));
    box.querySelectorAll('[data-box-size]').forEach(button => button.addEventListener('click', () => {
      selectedSize = button.dataset.boxSize;
      render();
      if (!ui.hidden) ui.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));

    stepsEl.addEventListener('click', event => {
      const change = event.target.closest('[data-box-change]');
      if (!change) return;
      drawerStep = change.dataset.boxChange;
      const meta = stepMeta[drawerStep];
      drawerStepEl.textContent = `${meta.number} / ${meta.editorial} · ${meta.label}`;
      alternativesEl.textContent = '';
      const currentVariant = selections[drawerStep]?.variant;
      availableFor(drawerStep).filter(candidate => candidate.variant !== currentVariant).forEach(candidate => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'hana-box-simple__alternative';
        button.dataset.altVariant = candidate.variant;
        button.appendChild(createProductImage(candidate));
        const vendor = document.createElement('span');
        vendor.textContent = candidate.vendor || 'HANA SELECT';
        const title = document.createElement('strong');
        title.textContent = candidate.title;
        const price = document.createElement('em');
        price.textContent = candidate.formattedPrice || formatMoney(candidate.price);
        button.append(vendor, title, price);
        alternativesEl.appendChild(button);
      });
      if (!alternativesEl.children.length) {
        const message = document.createElement('p');
        message.textContent = 'No hay otra alternativa disponible para este paso.';
        alternativesEl.appendChild(message);
      }
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
    });

    alternativesEl.addEventListener('click', event => {
      const button = event.target.closest('[data-alt-variant]');
      if (!button || !drawerStep) return;
      const replacement = availableFor(drawerStep).find(candidate => candidate.variant === button.dataset.altVariant);
      if (!replacement) return;
      selections[drawerStep] = replacement;
      drawer.hidden = true;
      document.body.style.overflow = '';
      render();
    });
    box.querySelectorAll('[data-box-close]').forEach(button => button.addEventListener('click', () => {
      drawer.hidden = true;
      document.body.style.overflow = '';
    }));

    const normalizeEasyBundleLabel = value => String(value || '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

    const waitForEasyBundlesSdk = async (timeout = 10000) => {
      const started = Date.now();
      while (Date.now() - started < timeout) {
        const sdk = window.gbbMix?.sdk;
        if (sdk?.f?.addItem && sdk?.f?.addBundleToCart && sdk?.state) return sdk;
        await new Promise(resolve => setTimeout(resolve, 120));
      }
      throw new Error('Easy Bundles SDK no está inicializado en esta página.');
    };

    const getEasyBundleSteps = sdk => {
      const candidates = [
        sdk?.state?.steps,
        sdk?.state?.bundleData?.steps,
        window.gbbMix?.settings?.mixAndMatchBundleData?.steps
      ];
      return candidates.find(Array.isArray) || [];
    };

    const easyBundleStepId = (sdk, hanaStep, orderIndex) => {
      const steps = getEasyBundleSteps(sdk);
      const aliases = {
        cleanse: ['limpieza', 'cleanse'],
        treat: ['serum tratamiento', 'serum', 'tratamiento', 'treat'],
        moisturise: ['hidratante', 'moisturise', 'moisturizer', 'hydrate'],
        protect: ['proteccion solar', 'solar', 'spf', 'protect']
      }[hanaStep] || [hanaStep];
      const matched = steps.find(step => {
        const label = normalizeEasyBundleLabel(step?.name || step?.title || step?.stepName || step?.label || step?.displayName);
        return aliases.some(alias => label.includes(normalizeEasyBundleLabel(alias)));
      }) || steps[orderIndex];
      return matched?.stepId || matched?.id || matched?._id || matched?.uuid || null;
    };

    const addEssentialWithEasyBundles = async () => {
      const sdk = await waitForEasyBundlesSdk();
      const hanaSteps = ['cleanse', 'treat', 'moisturise', 'protect'];
      const mapped = hanaSteps.map((step, index) => ({
        hanaStep: step,
        stepId: easyBundleStepId(sdk, step, index),
        variantId: Number(selections[step]?.variant || 0)
      }));
      if (mapped.some(item => !item.stepId || !item.variantId)) {
        throw new Error('No hemos podido relacionar los cuatro pasos de HANA con Easy Bundles.');
      }

      for (const item of mapped) {
        await sdk.f.addItem(item.stepId, item.variantId, 1);
        if (typeof sdk.f.checkStepLevelCondition === 'function') {
          const valid = await Promise.resolve(sdk.f.checkStepLevelCondition(item.stepId, item.variantId, 1));
          if (valid === false) throw new Error(`Easy Bundles no acepta la selección de ${stepMeta[item.hanaStep].label}.`);
        }
      }

      return new Promise(async (resolve, reject) => {
        let settled = false;
        const cleanup = () => {
          window.removeEventListener('gbb-add-bundle-to-cart-success', onSuccess);
          window.removeEventListener('gbb-add-bundle-to-cart-failed', onFail);
          clearTimeout(timer);
        };
        const onSuccess = () => {
          if (settled) return;
          settled = true;
          cleanup();
          resolve();
        };
        const onFail = event => {
          if (settled) return;
          settled = true;
          cleanup();
          reject(new Error(event?.detail?.message || 'Easy Bundles no ha podido añadir la HANA Box.'));
        };
        window.addEventListener('gbb-add-bundle-to-cart-success', onSuccess, { once: true });
        window.addEventListener('gbb-add-bundle-to-cart-failed', onFail, { once: true });
        const timer = setTimeout(() => onFail({ detail: { message: 'Easy Bundles no confirmó la adición al carrito.' } }), 12000);
        try {
          await sdk.f.addBundleToCart();
        } catch (error) {
          onFail({ detail: { message: error?.message || 'Error al añadir el bundle.' } });
        }
      });
    };

    addButton.addEventListener('click', async () => {
      const steps = activeSteps();
      if (steps.some(step => !selections[step]?.variant)) return;
      const original = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = 'AÑADIENDO…';

      try {
        const root = window.Shopify?.routes?.root || '/';
        if (selectedSize === 'essential') {
          await addEssentialWithEasyBundles();
          try { window.gbbExt?.utility?.handleSkaiLamaSideCartUpdate?.(); } catch (_) {}
          window.location.href = root + 'cart';
          return;
        }

        // Complete remains on the current HANA cart flow until a 6-step Easy Bundles offer is configured.
        const boxId = `HANA-${Date.now().toString(36).toUpperCase()}`;
        const items = steps.map(step => ({
          id: Number(selections[step].variant),
          quantity: 1,
          properties: {
            _hana_box_id: boxId,
            _hana_profile: profileLabels[selectedProfile],
            _hana_box_size: selectedSize,
            _hana_box_expected_count: String(steps.length),
            _hana_box_discount_pct: '0',
            _hana_step: stepMeta[step].label
          }
        }));
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('No se pudo añadir HANA Box');
        window.location.href = root + 'cart';
      } catch (error) {
        console.error('[HANA Box]', error);
        addButton.disabled = false;
        addButton.textContent = 'INTENTAR DE NUEVO';
        notice.textContent = selectedSize === 'essential'
          ? 'Easy Bundles todavía no está conectado a esta página. Añade el bloque “Bundle Embed (Advanced)” al puente HANA e introduce el Offer ID de HANA BOX · Essential.'
          : 'No hemos podido añadir la rutina. Revisa la disponibilidad e inténtalo de nuevo.';
        setTimeout(() => { addButton.textContent = original; }, 3000);
      }
    });
  }
});
